import React, { useState, useContext, useEffect } from "react";
import { Tabs } from "antd";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";
import apiUrl from "../../ApiEndpoint/config";
import apiClient from "../../ApiEndpoint/apiClient";
import Spinner from "../Spinner/spinner.js";

const { TabPane } = Tabs;

const BuildingInfo = () => {
    const { bldMasterId } = useContext(RegisterIdContext);
    const [buildingInfo, setBuildingInfo] = useState(null);
    const [loading, setLoading] = useState(true); // for spinner
    const [buldingSustainability, setBuildingSustainibility] = useState(null);
    const [buldingOverview, setBuildingOverview] = useState(null);

    useEffect(() => {
        if (!bldMasterId) return;

        const controller = new AbortController();

        const fetchBuildingInfo = async () => {
            try {
                setLoading(true);

                const [buildingListRes, sustainabilityRes, overviewRes] = await Promise.all([
                    apiClient.get(`${apiUrl}/building_list_table`, {
                        params: { master_id: bldMasterId },
                        signal: controller.signal,
                    }),
                    apiClient.get(`${apiUrl}/building_sustainability`, {
                        params: { master_id: bldMasterId },
                        signal: controller.signal,
                    }),
                    apiClient.get(`${apiUrl}/building_overview`, {
                        params: { master_id: bldMasterId },
                        signal: controller.signal,
                    }),
                ]);


                setBuildingInfo(buildingListRes.data?.building_list || []);
                setBuildingSustainibility(sustainabilityRes.data || {});
                setBuildingOverview(overviewRes.data || {});
            } catch (error) {
                if (apiClient.isCancel(error)) {
                } else {
                    console.error("Error fetching building info:", error);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchBuildingInfo();

        return () => controller.abort(); // cancel on cleanup
    }, [bldMasterId]);

    if (loading) {
        return <Spinner />;
    }
    return (
        <div className="card" style={{ padding: '10px' }}>
            <Tabs defaultActiveKey="1">
                {/* Owners Details tab with nested tabs */}
                <TabPane tab="Building Details" key="1">
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="Overview" key="1">
                            <Overview buildingInfo={buildingInfo} buldingOverview={buldingOverview} />
                        </TabPane>
                    </Tabs>
                </TabPane>

                <TabPane tab="Sustainability Goals" key="2">
                    <SustainabilityGoals buldingSustainability={buldingSustainability} />
                </TabPane>
                {/* <TabPane tab="News" key="3">
              
            </TabPane>
            <TabPane tab="Contacts" key="4">
              
            </TabPane> */}
            </Tabs>
        </div>
    );
};

const Overview = ({ buildingInfo, buldingOverview }) => {
    const data = buildingInfo?.[0] || {};
    const { Message, Citations } = buldingOverview;

    return (
        <div style={{ maxHeight: '55vh', overflowY: 'scroll' }}>
            <h5 style={{ color: '#098192', fontWeight: '800' }}>
                {data?.Master_Building_Name}
            </h5>
            <p>{Message}</p>
            <ul>
                {Citations.map((citation, index) => {
                    // Match Markdown-style [label](url)
                    const match = citation.match(/\[([^\]]+)\]\(([^)]+)\)/);
                    if (!match) return null;

                    const label = match[1];
                    const url = match[2];

                    return (
                        <li key={index}>
                            <span>{label}:</span>{" "}
                            <a href={url} target="_blank" rel="noopener noreferrer">
                                {url}
                            </a>
                        </li>
                    );
                })}
            </ul>
            <h6 style={{ fontWeight: '800' }}>Building Details</h6>
            <div className="details-grid">
                <span className="leftlabel">Building Name</span> <span> {data?.Master_Building_Name || "N/A"}</span>
                <span className="leftlabel">Building Owner</span> <span>{data?.ownerofrecord || "N/A"}</span>
                <span className="leftlabel">Building Type</span> <span>{data?.Master_Building_Type || "N/A"}</span>
                <span className="leftlabel">Building Area</span> <span>{data?.floor_area ? data?.floor_area + " sqft" : "N/A"}</span>
                <span className="leftlabel">State </span> <span>{data?.State_Name || "N/A"}</span>
                <span className="leftlabel">Year of completion</span> <span>{data?.year_built || "N/A"}</span>
                <span className="leftlabel">Green House Gas Emission</span> <span>{data?.GHG_Emissions_MetricTons ? data?.GHG_Emissions_MetricTons + " Metric tons" : "N/A"}</span>
                <span className="leftlabel">Energy Usuage Intensity</span> <span>{data?.Site_EUI_kBtu_per_sqft ? data?.Site_EUI_kBtu_per_sqft + " kBtu/ft²" : "N/A"}</span>
                <span className="leftlabel">Electricity Usage</span> <span>{data?.Electricity_Usage && data.Electricity_Usage !== 0 ? Math.round(data?.Electricity_Usage) + ' kWh' : "N/A"}</span>
                <span className="leftlabel">Other fuel Usage</span> <span>{data?.Other_Fuels_Usage && data.Other_Fuels_Usage !== 0 ? Math.round(data?.Other_Fuels_Usage) + ' kBtu' : "N/A"}</span>
                <span className="leftlabel">Stream Usage</span> <span>{data?.Steam_Usage && data.Steam_Usage !== 0 ? Math.round(data?.Steam_Usage) + ' kBtu' : "N/A"}</span>
                <span className="leftlabel">Hot Water Usage</span> <span>{data?.Hot_Water_Usage && data.Hot_Water_Usage !== 0 ? Math.round(data?.Hot_Water_Usage) + ' kBtu' : "N/A"}</span>
                <span className="leftlabel">Water Usage Intensity</span> <span>{data?.Water_Usage_Intensity && data.Water_Usage_Intensity !== 0 ? data.Water_Usage_Intensity + ' Gallons/ft²' : "N/A"}</span>
                <span className="leftlabel">Compliance Status</span> <span>{data?.compliance_status || "N/A"}</span>
                <span className="leftlabel">Electricity Price</span> <span>{data?.electricity_price + ' ¢/kWh' || "N/A"}</span>
            </div>

        </div>
    );
};

const SustainabilityGoals = ({ buldingSustainability }) => {
    const { Message, Citations } = buldingSustainability;
    return (
        <div>
            <h5
                style={{
                    color: "#098192",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    fontWeight: "800",
                }}
            >
                Sustainability Goals
            </h5>
            <p>{Message}</p>
            <ul>
                {Citations.map((citation, index) => {
                    // Match Markdown-style [label](url)
                    const match = citation.match(/\[([^\]]+)\]\(([^)]+)\)/);
                    if (!match) return null;

                    const label = match[1];
                    const url = match[2];

                    return (
                        <li key={index}>
                            <span>{label}:</span>{" "}
                            <a href={url} target="_blank" rel="noopener noreferrer">
                                {url}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default BuildingInfo;
